<template>
  <div class="width-100">
    <h2 class="section-title">{{ $t('advancedRevision.title') }}</h2>
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'AdvancedRevision',
  };
</script>
